import React, { createContext, useMemo, useState } from 'react';

import PropTypes from 'prop-types';

export const ErrorHandlingContext = createContext({});

export const ErrorHandlingContextProvider = ({ children }) => {
  const [showError, setShowError] = useState(false);

  const contextValue = useMemo(
    () => ({
      showError,
      setShowError,
    }),
    [showError, setShowError]
  );

  return (
    <ErrorHandlingContext.Provider value={contextValue}>{children}</ErrorHandlingContext.Provider>
  );
};

ErrorHandlingContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
